import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import Product from './pages/Product';
import ProductDetails from './pages/ProductDetails';
import Cart from './pages/Cart';
import WishList from './pages/Wishlist';
import Home from './pages/Home';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css'
import Checkout from './pages/Checkout';
import Order from './pages/Order';
import Account from './pages/Account';
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import PasswordReset from './pages/PasswordReset';
import ForgotPassword from './pages/ForgotPassword';
import LocationForm from './pages/LocationForm';
import VerifyOtp from './components/VerifyOtp';
import SellerRegister from './pages/SellerRegister';
import Dashboard from './pages/dashboard/overview';
import ProductDashboard from './pages/dashboard/product';
import Add from './pages/dashboard/AddProduct';
import Edit from './pages/dashboard/EditProduct';
import OrdersDashboard from './pages/dashboard/Order';
import ViewOrder from './pages/dashboard/ViewOrder';
import { ModalsProvider } from '@mantine/modals';

function App() {
  return (
    <MantineProvider>
    <ModalsProvider labels={{ confirm: 'Submit', cancel: 'Cancel' }}>
    <BrowserRouter>
    <ToastContainer />
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/product" element={<Product/>} />
      <Route path="/product/:id" element={<ProductDetails/>} />
      <Route path="/checkout" element={<Checkout/>} />
      <Route path="/cart" element={<Cart/>} />
      <Route path="/order" element={<Order/>} />
      <Route path="/wishlist" element={<WishList/>} />
      <Route path="/account" element={<Account/>} />
      <Route path="/signin" element={<Signin/>} />
      <Route path="/signup" element={<Signup/>} />
      <Route path="/reset" element={<PasswordReset/>} />
      <Route path="/forgot" element={<ForgotPassword/>} />
      <Route path="/location" element={<LocationForm/>} />
      <Route path="/seller" element={<SellerRegister/>} />
      <Route path='/dashboard'>
        <Route index element={<Dashboard/>}/>
        <Route path='product' element={<ProductDashboard/>}/>
        <Route path='product/add' element={<Add/>}/>
        <Route path='product/edit/:id' element={<Edit/>}/>
        <Route path='orders' element={<OrdersDashboard/>}/>
        <Route path='orders/:id' element={<ViewOrder/>}/>
      </Route>
    </Routes>
    </BrowserRouter>
    </ModalsProvider>

    </MantineProvider>
  );
}

export default App;
